import React, { useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import {
    Typography,
    FormControlLabel,
    Switch
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as Constants from "../common/Constants";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import LinearProgress from '@material-ui/core/LinearProgress';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: "column",
        height: "100%",
        paddingLeft: "16px"
    },
    heading: {
        color: theme.palette.primary.textColor,
        width: "100%",
        fontWeight: 600,
        fontSize: "40px"
    },
    firstName: {
        color: theme.palette.primary.textColor,
        fontSize: "72px",
        fontWeight: 600
    },
    lastName: {
        color: theme.palette.primary.main,
        fontSize: "72px",
        fontWeight: 600
    },
    jobRoleDiv: {
        paddingTop: "24px",
        display: "flex",
        flexDirection: "column"
    },
    jobRole: {
        fontSize: "24px",
        display: "flex",
        flexDirection: "row",
        fontWeight: 600
    },
    fromToDate: {
        fontSize: "24px",
        fontWeight: 500,
        paddingLeft: "12px",
        marginLeft: "auto",
        color: theme.palette.primary.main
    },
    jobCompany: {
        fontSize: "20px",
        fontWeight: 500,
        display: "flex",
        alignItems: "center"
    },
    skillBullets: {
        paddingTop: "12px",
        display: "flex",
        flexDirection: "column"
    },
    designation: {
        fontSize: "22px",
        fontWeight: 500
    },
    checkList: {
        display: "flex",
        flexDirection: "row",
        alignItems: "top"
    },
    checkIcon: {
        fontSize: "16px",
        marginRight: "12px",
        marginTop: "4px"
    },
    checkIconBig: {
        fontSize: "16px",
        marginRight: "12px",
        marginTop: "10px"
    },
    programHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "top",
        fontSize: "24px",
        fontWeight: 500
    },
    programContent: {
        marginLeft: "28px",
        display: "flex",
        alignItems: "top"
    },
    level: {
        width: "100px",
        height: "12px",
        marginLeft: "12px",
        marginTop: "6px"
    },
    expWith: {
        color: theme.palette.primary.main,
    },
    expWithLast: {
        color: theme.palette.primary.main,
        paddingBottom: "36px"
    },
    skillBulletLast: {
        paddingTop: "16px",
        paddingBottom: "36px",
        display: "flex",
        flexDirection: "column"
    },
    keyResponsibilities: {
        paddingTop: "12px",
        fontWeight: 600
    },
    openNewTabIcon: {
        paddingLeft: "4px",
        cursor: "pointer",
        "&:hover": {
            color: theme.palette.primary.main
        }
    }
}));

const Experience = () => {
    const classes = useStyles();

    const openNewTab = (url) => {
        window.open(url, '_blank');
    }

    return (
        <Typography component="div" className={classes.root}>
            <Typography component="div" className={classes.heading}>EXPERIENCE</Typography>
            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobRole}>Senior Software Engineer<Typography component="span" className={classes.fromToDate}>Aug 2018 - Present</Typography></Typography>
                <Typography component="span" className={classes.jobCompany}>Synamedia India Pvt. Ltd.<OpenInNewIcon onClick={() => openNewTab(Constants.SYNAMEDIA_URL)} className={classes.openNewTabIcon} /></Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} >Synamedia is a leader in the video/entertainment market with great customer base and has experienced management team who have the right strategy and vision in place.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Key responsibilities:</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Contributed to OpsHub Console which is a powerful tool for business operators to manage metadata from multiple applications with a single sign on.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Played a major role in technical analysis & design. Researched and developed microfrontend design which is now used across all the OpsHub modules.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Full stack development from frontend UIs to backend servers, microservices to Mongo DB and automating tests via cypress for each of the applications to manually testing all the features.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Actively reviewed pull requests from team mates in GitHub, participated in setting up Jenkins, automating CI/CD builds from GitHub, building docker images and deploying the builds using AWS Kubernetes.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Demonstrated the OpsHub Console features to the team, customers and stakeholders regularly.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Technologies:</Typography>
                <Typography component="span" className={classes.expWith}>React JS, Angular JS, JavaScript, HTML/CSS, Node JS, Java, Spring boot, Mongo DB, Cypress test framework, Docker and AWS Kubernetes for deployment.</Typography>
            </Typography>

            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobRole}>Software Engineer<Typography component="span" className={classes.fromToDate}>Oct 2015 - Jul 2018</Typography></Typography>
                <Typography component="span" className={classes.jobCompany}>OpenText Corporation<OpenInNewIcon onClick={() => openNewTab(Constants.OPENTEXT_URL)} className={classes.openNewTabIcon} /></Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} >OpenText Corporation is a Canadian company that develops and sells enterprise information management (EIM) software.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Key responsibilities:</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Contributed in development of AMEX Travel Invoice Management Portal and SIC projects.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Full stack development from frontend UIs to backend servers & MySQL database and manually testing all the features.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Manually deployed and tested the application in lab tenants and pre-production tenants. Automated few of the apache tomcat deployment steps.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Gethered requirements from stakeholders and gave proper estimates during requirement analysis and demonstrated the developed features to customers and stakeholders.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Technologies:</Typography>
                <Typography component="span" className={classes.expWith}>Angular JS, JavaScript, jQuery, HTML/CSS, Java, Spring boot, Hibernates and MySQL. </Typography>
            </Typography>

            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobRole}>Contractor<Typography component="span" className={classes.fromToDate}>Oct 2014 - Sep 2015</Typography></Typography>
                <Typography component="span" className={classes.jobCompany}>OpenText Corporation<OpenInNewIcon onClick={() => openNewTab(Constants.OPENTEXT_URL)} className={classes.openNewTabIcon} /></Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} >Worked as a contractor for OpenText Corporation for one year during which my performance was evaluated and I was made a permanent employee afterwards.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Key responsibilities:</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Contributed in development Trading Partner Automation project.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Full stack development from frontend UIs to backend servers & MySQL database and manually testing all the features.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Manually deployed and tested the application in lab tenants.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Demonstrated the developed features to the team.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Technologies:</Typography>
                <Typography component="span" className={classes.expWithLast}>JSP, Struts 2, JavaScript & jQuery, HTML/CSS, Java, Sprint & Hibernates, MySQL. </Typography>
            </Typography>
        </Typography>
    );
}

export default Experience;
